export default __webpack_public_path__ + "static/media/onboardingAside.227f2038.png";